'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NAME = exports.NAME = 'ldiMta';
var actionTypes = exports.actionTypes = {
  SUBMIT_MTA: NAME + '/SUBMIT_MTA',
  RESET_MTA: NAME + '/RESET_MTA',
  CLEAR_MTA: NAME + '/CLEAR_MTA'
};
var requiredFields = exports.requiredFields = {
  dates: ['licenceStartDate', 'vehiclePurchaseDate', 'dateOfBirth'],
  strings: ['policyId', 'title', 'forenames', 'surname', 'employmentStatus', 'industry', 'industryText', 'occupation', 'occupationText', 'hasClaims', 'email', 'telephone', 'regNo', 'abiCode', 'value', 'mainInsurer', 'modified', 'modifiedForDisability', 'postcodeKeptOvernight', 'keptOvernight', 'ownerRelation', 'owner', 'addressPostcode', 'addressLine1', 'addressLine2', 'addressTownCity', 'addressCounty', 'ownerEmail', 'vehicleOwnerPermission', 'thirdPartyPermission', 'thirdPartyName', 'thirdPartyEmail', 'year']
};